<stages-card #card [contentCollapsible]="contentCollapsible">
	<!--	[toolbarId]="toolbarId" [toolbarItems]="toolbarItems" [menuId]="menuId" [menuItems]="menuItems" [menuNoCollapse]="menuNoCollapse">-->
	<span stagesCardTitle class="h5" [translate]="title"></span>
	<ng-container stagesSlot="content" />
	@if (sequenceOptions && card.expanded) {
		<stages-add-sequence [sequences]="sequenceOptions" />
	}
</stages-card>
